<template>
    <div>
        <div class="locations-content organization-content">
            <b-button variant="light" class="back-button rounded-circle" :to="{ name: 'Locations' }" exact>
            </b-button>
            <h1 class="ml-3 d-inline-block products-heading">Products</h1>
            <div class="name-container">
                <div class="brand d-inline-block mr-3 px-3">
                    <p>Brand Name</p>
                    <h2>{{ branchInfo != null ? branchInfo.brand_name : "" }}</h2>
                </div>
                <div class="branch d-inline-block px-3">
                    <p>Branch Name</p>
                    <h2>{{ branchInfo != null ? branchInfo.name : "" }}</h2>
                </div>
            </div>
        </div>
        <div class="estore-content inventory-content">
            <PageToolBar />
            <DataTable />
            <Pagination />
        </div>
        <EditProduct
            :status="modal.edit_product.status"
            :basic_details="basic_details"
            :simple_product="simple_product"
            :product_variables="product_variables"
            :variation_items="variation_items"
            :payment="payment_type"
            :from_page="'locations-products'" />
    </div>
</template>

<script>
import PageToolBar from "@/components/locations/products/PageToolbar";
import DataTable from "@/components/locations/products/DataTable";
import Pagination from "@/components/locations/products/Pagination";
import EditProduct from "@/components/products/EditProduct";
import { mapState } from "vuex";

function initialBasicDetails() {
    return {
        name: "",
        description: "",
        product_variation: "simple",
        category_id: null
    };
}

function initialSimpleProduct() {
    return {
        on_sale: false,
        visibility: true,
        stock: 1,
        is_limited_stock: true,
        currency: "PHP",
        regular_price: "1",
        sku: null,
        discount_type: "%",
        discount_value: "1",
        on_sale_from: "YYYY-MM-DD HH:MM:SS",
        on_sale_to: "YYYY-MM-DD HH:MM:SS",
        options: {
            currency: [{ value: "PHP", text: "PHP" }],
            discount: [{ value: "%", text: "%" }, { value: "PHP", text: "PHP" }]
        },
        date_range: null
    };
}

function initialProductVariables() {
    return {
        attributes: [
            {
                name: "",
                action: "create",
                variations: [{ name: "", action: "create" }]
            }
        ],
        discount: {
            discount_type: "%",
            discount_value: 1
        },
        sale: {
            all: false,
            date_range: null
        }
    };
}

export default {
    name: "Products",
    data() {
        return {
            product_img_upload: {
                croppa: {},
                sliderVal: 0,
                sliderMin: 0,
                sliderMax: 0
            },
            basic_details: initialBasicDetails(),
            simple_product: initialSimpleProduct(),
            product_variables: initialProductVariables(),
            variation_items: [],
            variation_names: []
        };
    },
    components: {
        PageToolBar,
        DataTable,
        Pagination,
        EditProduct
    },
    props: ["branchUuid"],
    created: function() {
        this.getListProductInventoryByBranch();
    },
    methods: {
        formatDate: function(date) {
            return this.$moment(date).format("YYYY-MM-DD");
        },
        isMoment: function(date) {
            return this.$moment.isMoment(date);
        },
        getListProductInventoryByBranch: async function() {
            if (this.productInventoryListByBranch.length == 0) {
                let param = {
                    branchUuid: this.branchUuid,
                    page: 1,
                    payload: {
                        branch_uuid: this.branchUuid
                    }
                };
                await this.$store.dispatch(
                    "estoreLocations/getListProductInventoryByBranch",
                    param
                );
                
            }
        },
        getListProductInventoryByBranchAfterUpdate: async function() {
            let param = {
                branchUuid: this.branchUuid,
                page: this.pagination.currentPage,
                payload: {
                    branch_uuid: this.branchUuid
                }
            };
            await this.$store.dispatch(
                "estoreLocations/getListProductInventoryByBranch",
                param
            );
        },
        setBasicDetailsInit: function() {
            this.basic_details = initialBasicDetails();
        },
        setSimpleProductInit: function() {
            this.simple_product = initialSimpleProduct();
        },
        setProductVariablesInit: function() {
            this.product_variables = initialProductVariables();
        },
        setVariationItemsInit: function() {
            this.variation_items = [];
        }
    },
    computed: {
        ...mapState("estoreLocations", [
            "loading",
            "errors",
            "branchInfo",
            "productInventoryListByBranch",
            "modal",
            "payment_type",
            "pagination"
        ])
    },
    mounted() {
        this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
            this.$store.commit("estoreLocations/setModal", {
                type: "tag_products",
                status: false
            });
            this.$store.commit("estoreLocations/setModal", {
                type: "edit_brand",
                status: false
            });
            this.$store.commit("estoreLocations/setModal", {
                type: "edit_product",
                status: false
            });
        });
    }
};
</script>
